import React, { useEffect, useState } from "react";
import Icons from "../../../assets/icons/index";
import Button from "../../../components/common/button/Button";
import TextInput from "../../../components/common/input/TextInput";
import InputSelect from "../../../components/common/input/InputSelect";
import CustomerDetail from "../customer_detail/CustomerDetail";
import CustomerCreate from "../customer_create/CustomerCreate";
import styled from "./CustomerList.module.css";
import callApi from "../../../services/api/apiClient";
import { useSelector } from "react-redux";
import { customerSlice } from "../../../helper/customSlice";
import LoadingComponent from "../../../components/loading/LoadingComponent";
import ModalProvider from "../../../components/modal/ModalProvider";
import { Pagination } from "@mui/material";
import { dispatchStore } from "../../../lib/dispatchStore";

const CustomerList = () => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const [selectedTownship, setSelectedTownship] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [states, setStates] = useState([]);
  const [townships, setTownships] = useState([]);
  const [allLocation, setAllLocation] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  const customerList = useSelector((state) => state?.customerSlice?.list);
  console.log(customerList, "customerList");
  const Listpage = useSelector((state) => state?.customerSlice?.Listpage);
  const TotalPage = useSelector((state) => state?.customerSlice?.TotalPage);
  const reachEnd = useSelector((state) => state?.customerSlice?.reachEnd);

  useEffect(() => {
    getCustomerList();
  }, [searchValue, selectedState, selectedTownship, Listpage]);

  useEffect(() => {
    onDefaultPage();
    getAllLocations();
  }, []);

  const onDefaultPage = () => {
    dispatchStore(customerSlice.actions.setListpage(1));
  };

  const getAllLocations = () => {
    callApi("others/getAllLocations")
      .loadingGroup("createCustomer")
      .execute()
      .then((res) => {
        setAllLocation(res);
        setStates(res[0]?.state_ids);
      });
  };

  const getCustomerList = () => {
    let params = {
      page_no: Listpage,
      per_page: 10,
    };

    if (searchValue) {
      params.keywords = searchValue;
    }

    if (selectedState) {
      params.state_id = selectedState;
    }

    if (selectedTownship) {
      params.township_id = selectedTownship;
    }

    callApi("customer/customerList")
      .withParam(params)
      .loadingGroup("customerList")
      .execute()
      .then((res) => {
        dispatchStore(customerSlice.actions.setCustomerList(res));
      });
  };
  console.log("customer list...", getCustomerList);

  const onDeleteCustomer = () => {
    callApi("customer/deleteCustomer")
      .loadingGroup("customerList")
      .withKeyParameter({ id: customerId })
      .execute()
      .then((res) => {
        if (res.status === "success") {
          setIsDelete(false);
          getCustomerList();
        }
      });
  };

  const handleChange = (event, value) => {
    console.log("This is pagination page no", value);
    if (Listpage != undefined && reachEnd == false) {
      dispatchStore(customerSlice.actions.plusListpage(value));
    }
  };

  console.log("selected state....", selectedState);

  return (
    <div className={styled.list_container}>
      <div className="flex items-center">
        <p className={styled.title}>Customer List</p>
        <Button
          className={styled.create_customer}
          onClick={() => {
            setShowCreate(true);
            // window.location.replace('/customer_detail')
          }}
        >
          Create Customer
          <img
            src={Icons.addUser}
            alt=""
            className="w-[18px] h-[18px] ml-[10px]"
          />
        </Button>
      </div>
      <TextInput
        name={"Customer Name"}
        type="text"
        placeholder={"Search by name or phone"}
        className={"w-full outline-none  mt-[40px]"}
        onChange={(event) => {
          setSearchValue(event.target.value);
        }}
        value={searchValue}
      />
      <div className="flex mt-[18px] space-x-6">
        <InputSelect
          name={"state"}
          data={states}
          label={"State"}
          className={"w-full"}
          value={selectedState}
          onChange={(event) => {
            const val = states?.find(
              (v) => v?.id === event.target?.value
            )?.township_ids;
            setSelectedState(event.target.value);
            setTownships(val);
            setSelectedTownship(null);
          }}
          placeholder="Select"
        />
        <InputSelect
          name={"township"}
          data={townships}
          label={"Township"}
          className={"w-full"}
          disabled={selectedState ? false : true}
          value={selectedTownship}
          onChange={(event) => setSelectedTownship(event.target.value)}
          placeholder="Select"
        />
      </div>
      <LoadingComponent loadingGroup={"customerList"}>
        {customerList?.length > 0 ? (
          <table className={styled.table}>
            <thead className="text-left">
              <tr className={styled.table_header_row}>
                {/* <th className="">Product</th> */}
                <th>Customer Name</th>
                <th>Code</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Township</th>
                <th>State</th>
                <th className="text-center">Action</th>
                {/* <th className="w-2/12"></th> */}
              </tr>
            </thead>
            <tbody>
              {customerList?.map((item, index) => (
                <tr className="h-[64px] border-b border-b-black-2" key={index}>
                  {/* <td>
                                                {item?.image ?
                                                    <img src={item?.image} alt="" className="w-[56px] h-[48px]" /> :
                                                    <img src={Icons.defaultImage} alt="" className="w-[56px] h-[48px]" />
                                                }

                                            </td> */}
                  <td
                    className={`${styled.table_body_column} font-interSemiBold cursor-pointer`}
                    onClick={() => {
                      setShowDetail(true);
                      setSelectedCustomer(item);
                    }}
                  >
                    {item?.name}
                  </td>
                  <td
                    className={`${styled.table_body_column} font-interRegular`}
                  >
                    {item?.code ? item?.code : "-"}
                  </td>
                  <td
                    className={`${styled.table_body_column} font-interRegular`}
                  >
                    {item?.mobile ? item?.mobile : "-"}
                  </td>
                  <td
                    className={`${styled.table_body_column} font-interRegular`}
                  >
                    {item?.street ? item?.street : "-"}{" "}
                  </td>
                  <td
                    className={`${styled.table_body_column} font-interRegular`}
                  >
                    {item?.township?.name}
                  </td>
                  <td
                    className={`${styled.table_body_column} font-interRegular`}
                  >
                    {item?.state?.name}
                  </td>
                  <td className="flex-1">
                    <div
                      className="cursor-pointer  items-center flex justify-center"
                      onClick={() => {
                        setIsDelete(true);
                        setCustomerId(item?.id);
                      }}
                    >
                      <img
                        src={Icons.bin}
                        alt=""
                        className="w-[22px] h-[20px]"
                      />
                    </div>
                  </td>
                  {/* <td className="w-2/12"></td> */}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="flex justify-center items-center h-full">
            <p className={styled.not_found}>No customer data found.</p>
          </div>
        )}
        {customerList?.length > 0 && TotalPage > 1 && (
          <div className="flex justify-center mt-3  bottom-0 w-full ">
            <Pagination
              count={TotalPage}
              page={Listpage}
              onChange={handleChange}
              color="primary"
            />
          </div>
        )}
      </LoadingComponent>

      <CustomerDetail
        isOpen={showDetail}
        onClose={() => setShowDetail(false)}
        item={selectedCustomer}
        setShowDetail={setShowDetail}
        getCustomerList={getCustomerList}
      />
      <CustomerCreate
        isOpen={showCreate}
        onClose={() => setShowCreate(false)}
        getCustomerList={getCustomerList}
        idEdit={false}
      />
      <ModalProvider
        isOpen={isDelete}
        onClose={() => setIsDelete(false)}
        title={"Delete Customer Data"}
        cancelBtn={() => setIsDelete(false)}
        sendBtn={() => onDeleteCustomer()}
        description={"Are you sure you want to  delete this customer?"}
      />
    </div>
  );
};
export default CustomerList;
